import { useEffect, useMemo, useRef, useState } from 'react';
import { CouponService } from '../../../../services/CouponService';
import { ChangeAlertCallbackType } from '../../../Root';
import { Button } from '@mui/material';
import moment from 'moment';
moment.locale('es');

export const useCouponsTable = (changeAlert: ChangeAlertCallbackType) => {

    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [search, setSearch] = useState({campaing_uuid: '', partner_uuid: ''});
    const [disabledSearch, setDisabledSearch] = useState(true);
    const couponService = useRef<CouponService>();

    const getData = async () => {
        setLoading(true);
        const response = await couponService.current.couponsReport();
        setData(response.data?.content || []);
        setLoading(false);
    };

    const onHandleChange = (key, e) => {
        let s = search
        s[key] = e.target.value.trim()
        setSearch(JSON.parse(JSON.stringify(s)));
        setDisabledSearch(JSON.parse(JSON.stringify(!(s.partner_uuid && s.campaing_uuid))));
    }

    const onHandleSearch = async () => {
        setLoading(true);
        const response = await couponService.current.couponsPartnerPending(search);
        if (response.data.response === 'OK') {
            setData(response.data?.content?.pending || []);
        }
        if (response.data.code === '0016.005.011') {
            changeAlert(true, 'success', response.data.message);
        }
        setLoading(false);
    }

    const onReasign = async (uuid, item) => {
        setLoading(true);
        let req = {
            partner_uuid: item.partner_uuid.trim(),
            campaing_uuid: item.campaing_uuid.trim()
        }

        if(uuid){
            req['customer_uuid'] = uuid
        }
        const request = await couponService.current[uuid ? 'couponsPartnerReassign' : 'couponsPartnerBatchReAssign'](req);
        if (request.data.response === 'OK') {
            if(uuid && data.length < 2 ){
                setData([])
                setSearch({campaing_uuid: '', partner_uuid: ''})
            }
            if(uuid && data.length > 1 ){
                onHandleSearch();
            }
            changeAlert(true, 'success', 'La asignación se procesó correctamente');
        }
        setLoading(false);
    }

    useEffect(() => {
        couponService.current = new CouponService(changeAlert)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const calculateColumns = useMemo(() => {
        const columns = [
            { selector: (row) => row, name: 'Customer UUID', wrap: true, width: '85%', sortable: false },
            { cell: (row) => {
                return <Button variant='contained' onClick={onReasign.bind(this, row, search)} sx={{textTransform: 'none', fontFamily: 'inherit'}} color='secondary' >Reasignar</Button>
              }, name: 'Acción', width:'15%', wrap: true, sortable: true, center: true
            }
        ]
        
        return columns
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [search])

    return { columns: calculateColumns, data, loading, search, disabledSearch, onReasign, getData, onHandleChange, onHandleSearch }
};